var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                "label-col": _vm.labelCol2,
                "wrapper-col": _vm.wrapperCol2,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.activity.activitycode"],
                            prop: "activitycode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language[
                                "common.autosystemcode"
                              ],
                              disabled: ""
                            },
                            model: {
                              value: _vm.model.activitycode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "activitycode", $$v)
                              },
                              expression: "model.activitycode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.activity.activityname"],
                            prop: "activityname"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language[
                                "cs.activity.activityname"
                              ],
                              maxLength: "50"
                            },
                            model: {
                              value: _vm.model.activityname,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "activityname", $$v)
                              },
                              expression: "model.activityname"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.activity.startenddate"],
                            prop: "startdate",
                            labelCol: _vm.labelCol1,
                            wrapperCol: _vm.wrapperCol1
                          }
                        },
                        [
                          _c("a-date-picker", {
                            staticClass: "query-group-cust",
                            attrs: {
                              "show-time": "",
                              "disabled-date": _vm.disabledDate,
                              placeholder:
                                _vm.language["common.chooseStartDate"],
                              format: "YYYY-MM-DD HH:mm",
                              "value-format": "YYYY-MM-DD HH:mm"
                            },
                            model: {
                              value: _vm.model.startdate,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "startdate", $$v)
                              },
                              expression: "model.startdate"
                            }
                          }),
                          _c("span", { staticClass: "query-group-split-cust" }),
                          _c("a-date-picker", {
                            staticClass: "query-group-cust",
                            attrs: {
                              "show-time": "",
                              "disabled-date": _vm.disabledDate,
                              placeholder: _vm.language["common.chooseEndDate"],
                              format: "YYYY-MM-DD HH:mm",
                              "value-format": "YYYY-MM-DD HH:mm"
                            },
                            model: {
                              value: _vm.model.enddate,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "enddate", $$v)
                              },
                              expression: "model.enddate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language[
                              "cs.activity.seatstartenddate"
                            ],
                            prop: "seatstartdate",
                            labelCol: _vm.labelCol1,
                            wrapperCol: _vm.wrapperCol1
                          }
                        },
                        [
                          _c("a-date-picker", {
                            staticClass: "query-group-cust",
                            attrs: {
                              "show-time": "",
                              "disabled-date": _vm.disabledDate,
                              placeholder:
                                _vm.language["common.chooseStartDate"],
                              format: "YYYY-MM-DD HH:mm",
                              "value-format": "YYYY-MM-DD HH:mm"
                            },
                            model: {
                              value: _vm.model.seatstartdate,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "seatstartdate", $$v)
                              },
                              expression: "model.seatstartdate"
                            }
                          }),
                          _c("span", { staticClass: "query-group-split-cust" }),
                          _c("a-date-picker", {
                            staticClass: "query-group-cust",
                            attrs: {
                              "show-time": "",
                              "disabled-date": _vm.disabledDate,
                              placeholder: _vm.language["common.chooseEndDate"],
                              format: "YYYY-MM-DD HH:mm",
                              "value-format": "YYYY-MM-DD HH:mm"
                            },
                            model: {
                              value: _vm.model.seatenddate,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "seatenddate", $$v)
                              },
                              expression: "model.seatenddate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.venue.venuename"],
                            labelCol: _vm.labelCol1,
                            wrapperCol: _vm.wrapperCol1,
                            prop: "sysvenueid"
                          }
                        },
                        [
                          _c("a-Select", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              disabled: _vm.operation.visible,
                              options: _vm.selectVenueList,
                              "allow-clear": "",
                              "show-search": "",
                              optionFilterProp: "children",
                              placeholder: this.language["cs.venue.venuename"]
                            },
                            model: {
                              value: _vm.model.sysvenueid,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sysvenueid", $$v)
                              },
                              expression: "model.sysvenueid"
                            }
                          }),
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("場館一經選定無法修改")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.activity.address"],
                            labelCol: _vm.labelCol1,
                            wrapperCol: _vm.wrapperCol1,
                            prop: "address"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language["cs.activity.address"],
                              maxLength: "150"
                            },
                            model: {
                              value: _vm.model.address,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "address", $$v)
                              },
                              expression: "model.address"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol1,
                            wrapperCol: _vm.wrapperCol1,
                            label: this.language["cs.activity.photoinfo"],
                            prop: "activityfiles"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            staticClass: "avatar-uploader",
                            attrs: {
                              text: "上传",
                              "upload-source": _vm.uploadSource,
                              isMultiple: true,
                              disabled: _vm.disableSubmit
                            },
                            model: {
                              value: _vm.model.activityfiles,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "activityfiles", $$v)
                              },
                              expression: "model.activityfiles"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.activity.remark"],
                            labelCol: _vm.labelCol1,
                            wrapperCol: _vm.wrapperCol1,
                            prop: "remark"
                          }
                        },
                        [
                          _c("j-editor", {
                            attrs: {
                              placeholder: this.language["cs.activity.remark"]
                            },
                            model: {
                              value: _vm.model.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "remark", $$v)
                              },
                              expression: "model.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }